import { GTMEventsInterface, MixpanelPropertiesInterface } from './@core/interfaces';

export const POLLY_MANAGE_CUSTOM_EVENT: string = 'PollyManageCustomEvent';

export const GTMEvents: GTMEventsInterface = {
  HOME: 'Home',
  WORKSPACES: 'Workspaces',
  APPS: 'Applications',
  DATA_LAKES: 'DataLakes',
  DISCOVER: 'Discover',
  OMIXATLAS: 'Omixatlas',
  INTERCOM: 'Intercom',
  INTERCOM_NEW_CONVERSATION: 'Intercom_NewConversation',
  INTERCOM_SEE_PREVIOUS: 'Intercom_SeePrevious',
  USER_PROFILE_LOGOUT: 'UserProfile_LogOut',
  FILE_UPLOAD: 'NewFileUpload_Box_Upload',
  EMAIL_INITIALIZATION: 'user-email',
  ADD_COLLABORATOR_TOOLTIP: 'add_collaborator_tooltip',

  SEARCH_BAR: 'SearchBar',
  NOTEBOOK: 'Notebook',
  SELECT_WORKSPACE: 'SelectWorkspace',
  SELECT_WORKSPACE_SELECT: 'SelectWorkspace_Select',
  NOTEBOOK_NAME: 'Notebook_Name',
  NOTEBOOK_DOCKER: 'Notebook_Docker',
  NOTEBOOK_MACHINE: 'Notebook_Machine',
  DONE: 'Done',
  APPLICATIONS_WORKSPACE: 'Applications_Workspace',
  APPLICATIONS_WORKSPACE_SELECT: 'Applications_Workspace_Select',
  APPLICATIONS_NAME: 'Applications_Name',
  APPLICATIONS_SUBMIT: 'Applications_Submit',
  DATASET: 'Dataset',
  SOURCE: 'Source',

  SIDEBAR_TOGGLE: '<>',
  NEW_WORKSPACE: 'NewWorkspace',
  NAME: 'Name',
  DESCRIPTION: 'Description',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  NEW: 'New',
  FILTER: 'Filter',
  HIDE_FILES: 'HideFiles',
  HIDE_FOLDERS: 'HideFolders',
  HIDE_NOTEBOOKS: 'HideNotebooks',
  HIDE_ANALYSES: 'HideAnalyses',
  HIDE_REPORTS: 'HideReports',
  CLEAR: 'Clear',
  FOLDER: 'Folder',
  FOLDER_NAME: 'Folder_Name',
  FOLDER_CREATE_FOLDER: 'Folder_CreateFolder',
  KEBAB_MENU: 'KebabMenu',
  EDIT: 'Edit',
  RENAME: 'Rename',
  CLONE: 'Clone',
  LAUNCH: 'Launch',
  EDIT_AND_LAUNCH: 'Edit_and_Launch',
  VERSION: 'Version',
  RESTORE: 'Restore',
  ALGORITHM: 'Algorithm',
  TERMINATE: 'Terminate',
  SELECT: 'Select',
  SELECT_ALL: 'Select_All',
  DELETE: 'Delete',
  MOVE: 'Move',
  COPY: 'Copy',
  SEARCH: 'Search',
  VIEW: 'View',
  FILE: 'File',
  APP: 'App',
  OCR: 'OCR',
  BACK: 'Back',
  KNOWLEDGE_REPO: 'Knowledge_Repo',
  DOWNLOAD: 'Download',
  ANALYSIS: 'Analysis',
  TAB: 'Tab',
  DETAIL: 'Detail',
  HISTORY: 'History',
  DIALOG: 'Dialog',
  APPLY_AND_CLOSE: 'Apply_and_Close',

  COLLABORATORS: 'Collaborators',
  PERMISSION_DROPDOWN1: 'PermissionDropDown1',
  PERMISSION_DROPDOWN2: 'PermissionDropDown2',
  ADD: 'Add',
  YES: 'Yes',
  NO: 'No',

  OMIXATLAS_DOWNLOAD: 'OmixAtlas_Download',
  OMIXATLAS_LAUNCH_APP: 'OmixAtlas_LaunchApp',
  OMIXATLAS_VIEW_DETAILS: 'OmixAtlas_Viewdetails',
  OMIXATLAS_VIEW_ALL_DATA: 'OmixAtlas_ViewAllData',
  OMIXATLAS_FILTERS: 'OmixAtlas_Filters',
  OMIXATLAS_SEARCH: 'OmixAtlas_Search',
  OMIXATLAS_REQUEST_DATASET: 'OmixAtlas_RequestADataset',
  OMIXATLAS_COPY_TO_WORKSPACE: 'OmixAtlas_CopyToWorkspace',
  OMIXATLAS_VIEW_REPORT: 'OmixAtlas_ViewReport',
  OMIXATLAS_REQUEST_CURATION_AND_QC: 'OmixAtlas_RequestCurationAndQC',
  OMIXATLAS_CARD_VIEW: 'OmixAtlas_CardView',
  OMIXATLAS_TABLE_VIEW: 'OmixAtlas_TableView',
  OMIXATLAS_BUY_DATA: 'OmixAtlas_BuyData',
  OMIXATLAS_SEARCH_SELECT: 'OmixAtlas_SearchSelect',
  OMIXATLAS_SEARCH_EXECUTE: 'OmixAtlas_SearchExecute',
  OMIXATLAS_GENE_SEARCH_COMP_DETAILS_OPEN: 'OmixAtlas_Gene_Search_Comp_Details_Open',
  OMIXATLAS_KEYWORD_SEARCH_CARD_TAB_SWITCH: 'OmixAtlas_Keyword_Search_Card_Tab_Switch',
  OMIXATLAS_KEYWORD_SEARCH_CARD_COMP_DETAILS_OPEN: 'OmixAtlas_Keyword_Search_Card_Comp_Details_Open',
  OMIXATLAS_SEARCH_PAGINATION: 'OmixAtlas_Search_Pagination',
  OMIXATLAS_DATA_DETAILS_TAB_SWITCH: 'OmixAtlas_Data_Details_Tab_Switch',
  OMIXATLAS_DATA_DETAILS_SUNBURST_UPDATE: 'OmixAtlas_Data_Details_Sunburst_Update',
  OMIXATLAS_DATA_DETAILS_PCA_UPDATE: 'OmixAtlas_Data_Details_PCA_Update',
  OMIXATLAS_DATA_DETAILS_COMP_DETAILS_OPEN: 'OmixAtlas_Data_Details_Comp_Details_Open',
  OMIXATLAS_DATA_DETAILS_SAMPLE_MANAGE: 'OmixAtlas_Data_Details_Sample_Manage',
  OMIXATLAS_COMP_DETAILS_PLOT_SWITCH: 'OmixAtlas_Comp_Details_Plot_Switch',
  OMIXATLAS_COMP_DETAILS_GENE_SEARCH: 'OmixAtlas_Comp_Details_Gene_Search',
  OMIXATLAS_COMP_DETAILS_PATHWAY_SEARCH: 'OmixAtlas_Comp_Details_Pathway_Search',
  OMIXATLAS_COMP_DETAILS_PATHWAY_SELECT: 'OmixAtlas_Comp_Details_Pathway_Select',
  OMIXATLAS_COMP_DETAILS_HEATMAP_SIZE: 'OmixAtlas_Comp_Details_Heatmap_Size',
  OMIXATLAS_COMP_DETAILS_PATHWAY_SIZE: 'OmixAtlas_Comp_Details_Pathway_Size',
  OMIXATLAS_COMP_DETAILS_VOLCANO_UPDATE: 'OmixAtlas_Comp_Details_Volcano_Update',
  OMIXATLAS_COMP_DETAILS_PLOTS_SIDE_BY_SIDE: 'OmixAtlas_Comp_Details_Plots_Side_By_Side',

  WORKSPACES_CARD_VIEW: 'Workspaces_CardView',
  WORKSPACES_FILE_PREVIEW: 'Workspaces_FilePreview',
  WORKSPACES_FILE_DELETE_PERMANENTLY: 'Workspaces_Files_Delete_DeletePermanently',
  WORKSPACES_FILE_PREVIEW_DOWNLOAD_ICON: 'Workspaces_FilePreview_Downloadicon',
  WORKSPACES_FILE_PREVIEW_LARGE_TABULAR_FILE_DOWNLOAD: 'Workspaces_FilePreview_LargeTabularFile_Download',
  WORKSPACE_FILE_PREVIEW_COPY_LINK: 'Workspaces_FilePreview_CopyLink',
  WORKSPACES_COPY: 'Workspaces_Copy',
  WORKSPACES_COPY_FILES: 'Workspaces_Copy_CopyFiles',
  WORKSPACES_MOVE: 'Workspaces_Move',
  WORKSPACES_MOVE_FILES: 'Workspaces_Move_MoveFiles',
  WORKSPACES_COPY_MOVE_SAME_PATH: 'Workspaces_CopyMove_SamePath',
  WORKSPACES_STATUS_DROPDOWN: 'Workspaces_Status_Dropdown',
  WORKSPACES_STATUS_DROPDOWN_ACTIVE: 'Workspaces_Status_Dropdown_Active',
  WORKSPACES_STATUS_DROPDOWN_ARCHIVED: 'Workspaces_Status_Dropdown_Archived',
  WORKSPACE_ARCHIVE: 'Workspaces_ArchiveWorkspace',
  WORKSPACES_RESTORE_WORKSPACE: 'Workspaces_RestoreWorkspace',
  WORKSPACE_DELETE_PERMANENTLY: '_DeletePermanently',
  WORKSPACE_DELETE_PERMANENTLY_BUTTON: 'DeletePermanentlyButton',
  NEWWORKSPACE_CREATE: 'NewWorkspace_Create',
  NEWWORKSPACE_CANCEL: 'NewWorkspace_Cancel',
  NEWWORKSPACE_CREATE_AND_LAUNCH: 'NewWorkspace_Create_and_Launch',
  WORKSPACE_EDIT: 'EditDetails',
  WORKSPACE_EDIT_CANCEL: 'EditDetails_Cancel',
  WORKSPACE_FAVOURITE: 'Star_Favourite',
  WORKSPACE_WATCH: 'Eye_Watch',
  WORKSPACE_OPEN: 'Open_Workspace',
  WORKSPACE_REMOVE_COLLABORATOR: 'Share_Remove_Collaborator',
  WORKSPACE_ADD_COLLABORATORS: 'Share_Add_Collaborators',
  WORKSPACE_COLLABORATOR_UPDATE_PERMISSION: 'Share_Update_Collaborator_Permission',
  WORKSPACE_SHARE_CANCEL: 'Share_Cancel',
  WORKSPACE_SHARE_DONE: 'Share_Done',

  POLLY_CLI: 'PollyCLI',

  SAGEMAKER_NOTEBOOK_LOAD_TIME: 'Sagemaker_Notebook_Load_Time',

  ATLAS_ERD: 'Atlas_ERD',
  ATLAS_SQL: 'Atlas_SQL',
  ATLAS_TABLE: 'Atlas_Table',
  ATLAS_DOWNLOAD: 'Atlas_Download',
  ATLAS_DOWNLOAD_SQL: 'Atlas_Download_SQL',
  ATLAS_SORT: 'Atlas_Sort',
  ATLAS_FILTER_VALUE: 'Atlas_Filter_Value',
  ATLAS_FILTER_CONDITIONAL: 'Atlas_Filter_Conditional',
  ATLAS_CREATE: 'Atlas_Create',
  ATLAS_EDIT: 'Atlas_Edit',
  ATLAS_MANAGE_USERS: 'Atlas_Manage_Users',
  ATLAS_ARCHIVE: 'Atlas_Archive',

  POLLY_PIPELINES: 'Polly_Pipelines',
  PIPELINE_DETAILS: 'Pipeline_Details',
  PIPELINE_EDIT: 'Pipeline_Edit',
  PIPELINE_EDIT_CANCEL: 'Pipeline_EditCancel',
  PIPELINE_EDIT_SAVE: 'Pipeline_EditSave',
  PIPELINE_COLLABORATOR: 'Pipeline_Collaborator',
  PIPELINE_COLLABORATOR_CANCEL: 'Pipeline_CollaboratorCancel',
  PIPELINE_COLLABORATOR_SAVE: 'Pipeline_CollaboratorSave',
  PIPELINE_COLLABORATOR_ADD: 'Pipeline_CollaboratorAdd',
  PIPELINE_COLLABORATOR_DELETE: 'Pipeline_CollaboratorDelete',
  PIPELINE_SEARCH: 'Pipeline_Search',
  PIPELINE_DETAILS_CANCEL: 'Pipeline_DetailsCancel',
  PIPELINE_DETAILS_SUBMIT: 'Pipeline_DetailsSubmit',
  BATCH_EDIT: 'Batch_Edit',
  BATCH_EDIT_CANCEL: 'Batch_EditCancel',
  BATCH_EDIT_SAVE: 'Batch_EditSave',
  BATCH_SEARCH: 'Batch_Search',
  BATCH_STATUS_FILTER: 'Batch_StatusFilter',
  BATCH_STATUS_FILTER_CLEAR: 'Batch_StatusFilterClear',
  BATCH_STARTED_BY_FILTER: 'Batch_StartedByFilter',
  BATCH_STARTED_BY_FILTER_CLEAR: 'Batch_StartedByFilterClear',
  BATCH_STARTED_ON_SORT: 'Batch_StartedOnSort',
  BATCH_STARTED_ON_VALUE: 'Batch_StartedOnValue',
  BATCH_STARTED_ON_VALUE_CLEAR: 'Batch_StartedOnValueClear',
  BATCH_PRIORITY_FILTER_SORT: 'Batch_PriorityFilterSort',
  BATCH_PRIORITY_FILTER_VALUE: 'Batch_PriorityFilterValue',
  BATCH_PRIORITY_FILTER_VALUE_CLEAR: 'Batch_PriorityFilterValueClear',
  BATCH_DETAILS: 'Batch_Details',
  RUN_DETAILS: 'Run_Details',
  RUN_SEARCH: 'Run_Search',
  RUN_STATUS_FILTER: 'Run_StatusFilter',
  RUN_STATUS_FILTER_CLEAR: 'Run_StatusFilterClear',
  RUN_STARTED_ON_SORT: 'Run_StartedOnSort',
  RUN_STARTED_ON_VALUE: 'Run_StartedOnValue',
  RUN_STARTED_ON_VALUE_CLEAR: 'Run_StartedOnValueClear',
  RUN_LOGS: 'Run_Logs',
  RUN_LOGS_DOWNLOAD: 'Run_LogsDownload',
  RUN_PARAMETERS: 'Run_Parameters',
  RUN_TASK: 'Run_Task',
  RUN_TASK_DETAILS: 'Run_Task_Details',
  RUN_TASK_LOGS: 'Run_Task_Logs',
  RUN_TASK_LOGS_DOWNLOAD: 'Run_Task_LogsDownload',
  RUN_TASK_PARAMETERS: 'Run_Task_Parameters',
};

export const mixpanelEventProperties: MixpanelPropertiesInterface = {
  Dataset_Id: '',
  Repository_Id: '',
  Repository_Name: ''
};
